package fr.frux.core.billing

actual fun createBillingPlatform(): BillingPlatform? = null
